import RCEManager from './manager'

export * from './types'
export * from './data/events'
export * from './data/playerKill'
export * from './data/quickChat'

export default RCEManager
export { RCEManager }
